<script setup>
import { ToastTypeEnum } from '@/lib/ui'
import { esNotification } from 'escs-frontend-library'
import { toRefs } from 'vue'

const emit = defineEmits([ 'dismiss' ])
const props = defineProps({
	message: {
		type: String,
		required: true
	},
	type: {
		type: String,
		default: ToastTypeEnum.Info,
	},
})
const { type } = toRefs(props)

</script>
<template lang="pug">
esNotification(show :type="type" :message="message" @closed="emit('dismiss')")
</template>
